import { ChangeDetectionStrategy, Component, computed, input } from "@angular/core";
import { MatCard, MatCardContent } from "@angular/material/card";
import { MatIcon } from "@angular/material/icon";
import { CardHeaderComponent } from "../../shared/card-header/card-header.component";
import { TodoListComponent } from "../../shared/todo-list/todo-list.component";
import { isSubAgentTodoListDone } from "../../../../model/block.types";
import type { SubAgentTodo } from "../../../../model/block.types";
import type { WorkerToolCall } from "../../../../services/worker-todo-stream.service";

/**
 * Standalone card wrapper around `TodoListComponent` for a sub-agent's TODO checklist that
 * streams as part of a plain conversational turn (no `background_job` wrapper) — e.g. a
 * `write_todos`-backed sub-agent invoked directly in chat. Rendered by `ChatMessageListComponent`
 * from `WorkerTodoStreamService`'s live list, alongside the other content cards in the
 * conversation. `TaskListCardComponent` renders the same `TodoListComponent` nested inside a
 * pipeline phase instead of in its own card — this component is the counterpart for when there
 * is no pipeline card to nest inside. The tool-call activity row above the checklist mirrors
 * `TaskListCardComponent`'s `task-list-card__activity-row` for `deepAnalysis.toolCall`.
 */
@Component({
  selector: "app-todo-list-card",
  standalone: true,
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [MatCard, MatCardContent, MatIcon, CardHeaderComponent, TodoListComponent],
  templateUrl: "./todo-list-card.component.html",
  styleUrl: "./todo-list-card.component.scss",
})
export class TodoListCardComponent {
  readonly todos = input.required<SubAgentTodo[]>();

  readonly title = input<string>("To-do list");

  /** Last completed tool call for this turn's sub-agent — shown as an activity row above the checklist while running. */
  readonly toolCall = input<WorkerToolCall | null>(null);

  protected readonly isDone = computed<boolean>(() => isSubAgentTodoListDone(this.todos()));
}
